// this is the right one to use
const BoardMemberCurr = ({ member }) => {
    return (
        <>
            <img src={member.imageSrc} alt={member.name} className="profile-pic" />
            <div className="description">
                <h2>{member.position}</h2>
                <p><strong>{member.name}</strong> <i>
                    {member.pronouns && (
                    <>
                        ({member.pronouns})
                    </>
                )}
                </i></p>
                <p>{member.ipa}</p>
                <br></br>
                {member.major && (
                    <>
                        <p><strong>Major:</strong> {member.major}</p>
                    </>
                )}
                {member.minor && (
                    <>
                        <p><strong>Minor:</strong> {member.minor}</p>
                    </>
                )}
                <br></br>
                {member.gradYear && (
                    <>
                        <p><strong>Class of  {member.gradYear}</strong></p>
                    </>
                )}
                <br></br>
                {member.favoriteLingArea && (
                    <>
                        <p><strong>Favorite Area of Ling:</strong> </p><p>{member.favoriteLingArea}</p>
                    </>
                )}
                <br></br>
                {member.favoriteDrink && (
                    <>
                        <p><strong>Favorite Drink Order:</strong> </p> <p>{member.favoriteDrink}</p>
                    </>
                )}
            </div>
        </>
    );
};
export default BoardMemberCurr;